import React, { useEffect, useRef, useState } from 'react';
import { BUILD } from './version';

type Kind = 'about';

/** The About button: the paper's people and, below them, who developed the app. The details show when the mouse is over the button (or it is clicked / tapped). */
export function InfoMenu() {
  const [open, setOpen] = useState<Kind | null>(null);
  const [pinned, setPinned] = useState<Kind | null>(null);
  const box = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!pinned) return;
    const away = (e: MouseEvent | TouchEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) {
        setPinned(null);
        setOpen(null);
      }
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setPinned(null);
        setOpen(null);
      }
    };
    document.addEventListener('mousedown', away);
    document.addEventListener('touchstart', away);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', away);
      document.removeEventListener('touchstart', away);
      document.removeEventListener('keydown', esc);
    };
  }, [pinned]);

  const item = (k: Kind, label: string, tone: string, body: React.ReactNode) => {
    const shown = open === k || pinned === k;
    return (
      <span
        className="info-item"
        onMouseEnter={() => !pinned && setOpen(k)}
        onMouseLeave={() => !pinned && setOpen(null)}
      >
        <button
          className={'cbtn ' + tone}
          aria-expanded={shown}
          onClick={() => {
            const n = pinned === k ? null : k;
            setPinned(n);
            setOpen(n);
          }}
          onFocus={() => !pinned && setOpen(k)}
          onBlur={() => !pinned && setOpen(null)}
        >
          {label}
        </button>
        {shown && (
          <div className="info-card" role="tooltip">
            {body}
          </div>
        )}
      </span>
    );
  };

  return (
    <span className="info-menu" ref={box}>
      {item(
        'about',
        'About',
        'tone-teal',
        <dl className="info-rows">
          <dt>Chief-Editor</dt>
          <dd>Challa Srinivasa Rao</dd>
          <dt>Phone</dt>
          <dd>
            <a className="info-phone" href="tel:+917396014218">+91 7396014218</a>
          </dd>
          <dt>Editor</dt>
          <dd>Challa Srikanth</dd>
          <dt className="info-sep">Developed By</dt>
          <dd className="info-sep">Jaya kumar Garikipati</dd>
          <dt>Phone</dt>
          <dd>
            <a className="info-phone" href="tel:+919966696911">+91 9966696911</a>
          </dd>
          <dt>Phone</dt>
          <dd>
            <a className="info-phone" href="tel:+918148118148">+91 8148118148</a>
          </dd>
          <dt className="info-sep">Version</dt>
          <dd className="info-sep">{BUILD}</dd>
        </dl>
      )}
    </span>
  );
}
